import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M512 1024A512 512 0 0115.36 388.267 512 512 0 01950.613 248.32a508.16 508.16 0 0158.027 387.413A512 512 0 01512 1024zm0-998.4a486.4 486.4 0 00-117.76 958.293A486.4 486.4 0 00983.893 629.76 486.4 486.4 0 00629.76 40.107 488.96 488.96 0 00512 25.6zm-50.773 699.733l-89.6-179.2h-80.64v179.2h-64.854V298.667h165.12a121.6 121.6 0 01132.267 124.16 111.787 111.787 0 01-85.333 113.066l98.133 189.44zm-74.667-367.36h-95.573v133.12h95.573a66.987 66.987 0 100-133.12zm336.213 367.36V793.6h-49.066v-64.853a186.453 186.453 0 01-136.107-56.32l42.667-42.667a138.24 138.24 0 0098.56 42.667V538.453h-15.36a145.92 145.92 0 01-80.214-34.133 106.24 106.24 0 01-31.573-81.493 121.6 121.6 0 01122.027-124.16v-55.04h49.066v55.04a170.667 170.667 0 01113.92 47.786l-42.666 42.667a125.013 125.013 0 00-78.08-32.427v128l20.48 2.987a140.8 140.8 0 0179.36 31.573 111.36 111.36 0 0134.56 85.334c2.986 70.4-50.347 115.2-127.574 120.746zM680.107 352a64.427 64.427 0 00-65.707 66.56 50.773 50.773 0 0016.213 39.253 88.32 88.32 0 0048.214 19.627zm92.16 208.213a85.333 85.333 0 00-49.494-17.92h-4.266v128c42.666-4.266 70.4-26.88 70.4-64a57.173 57.173 0 00-17.92-44.8z"
});

function SvgBrl(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "BRL_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrl);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'BRLOutlined';

export default KuFoxIcons;
